export const events = {
  RESIZE: 'RESIZE',
  HELP_BUTTON_CLICK: 'HELP_BUTTON_CLICK',
  MUSIC_BUTTON_CLICK: 'MUSIC_BUTTON_CLICK',
}
